import * as analytics from '../vendor/analytics/index';
import { getParameterByName } from './queryStringHelper';
import templateData from './getTemplateData';
import _get from 'lodash/get';
import _find from 'lodash/find';

function parseFPTIValue(key) {
  let fptiData;
  try {
    fptiData = JSON.parse(document.getElementById('fptiData').innerHTML || {});
  } catch (e) {
    fptiData = {};
  }
  let nameValues = [];
  let pairs = decodeURIComponent(fptiData).split('&');
  let i;
  for (i = 0; i < pairs.length; i++) {
    let parts = pairs[i].split('=');
    nameValues[parts[0]] = parts[1];
  }
  return nameValues[key];
}

const urlToFptiMapping = [
  {
    url: '/donate/guest/crossborder',
    pgrp: 'main:donate:wps:guest:crossborder',
  },
  { url: '/donate/error/payment', pgrp: 'main:donate:wps:guest:failure' },
  { url: '/donate/member/success', pgrp: 'main:donate:wps:member:success' },
  {
    url: '/donate/member/confirmation-rec',
    pgrp: 'main:donate:wps:member:success',
  },
  {
    url: '/donate/member/confirmation',
    pgrp: 'main:donate:wps:member:success',
  },
  { url: '/donate/member/pending', pgrp: 'main:donate:wps:member:pending' },
  { url: '/donate/member/error', pgrp: 'main:donate:wps:member:failure' },
  { url: '/donate/member', pgrp: 'main:donate:wps:member:review' },
];

function getPgrp() {
  try {
    const windowUrl = window.location.href;
    const signup = getParameterByName('signup');
    if (signup) {
      return 'main:donate:wps:signup:signupform';
    }

    for (let i = 0; i < urlToFptiMapping.length; i++) {
      if (windowUrl.indexOf(urlToFptiMapping[i].url) > -1) {
        return urlToFptiMapping[i].pgrp;
      }
    }

    if (windowUrl.indexOf('/donate/guest/confirmation') > -1) {
      if (templateData.fptPageName === 'guestULSignUp') {
        return 'main:donate:wps:signup:success';
      }
      return 'main:donate:wps:guest:success';
    }

    if (windowUrl.indexOf('/donate/guest/pending') > -1) {
      if (templateData.fptPageName === 'guestULSignUp') {
        return 'main:donate:wps:signup:pending';
      }
      return 'main:donate:wps:guest:pending';
    }

    // Last of the guest pages
    if (windowUrl.indexOf('/donate/guest') > -1) {
      return 'main:donate:wps:guest:guestform';
    }

    // Last check. Is it landing page?
    if (windowUrl.indexOf('/donate') > -1) {
      return 'main:donate:wps::landing';
    }
  } catch (error) {
    trackError({
      message: 'FPTI_PGRP_ERROR',
      code: window.location.href,
      error,
    });
  }

  // No pages matched. Use value sent by server
  return {
    pgrp: parseFPTIValue('pgrp'),
    page: parseFPTIValue('page'),
  };
}

export function trackPage(pageGroup, pageName, custKey, custValue) {
  analytics.trackPage(pageGroup, pageName, custKey, custValue);
}

export function trackPageWithData(pageGroup, pageName, data) {
  analytics.trackPageWithData(pageGroup, pageName, data);
}

export function addPxpTags(data) {
  analytics.addPxpTags(data);
}

export function trackLinkClick(eventType) {
  const pgrp = getPgrp();
  analytics.trackLink(eventType, pgrp, `${pgrp}:web::`, 'link');
}

export function trackLinkClickWithData(eventType, data) {
  const pgrp = getPgrp();
  analytics.trackLinkWithData(eventType, pgrp, `${pgrp}:web::`, data, 'link');
}

export function trackButtonClick(eventType) {
  const pgrp = getPgrp();
  analytics.trackLink(eventType, pgrp, `${pgrp}:web::`, 'link');
}

export function trackButtonClickWithData(eventType, data) {
  const pgrp = getPgrp();
  analytics.trackLinkWithData(eventType, pgrp, `${pgrp}:web::`, data, 'link');
}

export function trackError(err) {
  analytics.trackError(err);
}

export function addFi(fundingOpts, pageGroup, pageName) {
  window.fpti.fi_id = _get(fundingOpts, 'id');
  // payment card type
  window.fpti.fi_type = _get(fundingOpts, 'sources[0].payment_card.type');
  // payment card network
  window.fpti.sel_fmx_tp = _get(fundingOpts, 'sources[0].payment_card.network');
  window.fpti.fi_operation = 'add_card';
  trackPage(pageGroup, pageName);
}

export function add3DSInitData(fundingOpts, pageGroup, pageName) {
  window.fpti.is_3ds_eligible = true;
  window.fpti['3ds_version'] = '3DS2.0';

  const contingencies = _get(fundingOpts, 'contingencies') || [];
  const threeDSContingency =
    _find(contingencies, { action: '3D_SECURE_DATA_COLLECTION_REQUIRED' }) ||
    {};
  window.fpti['3ds_ref_id'] = _get(threeDSContingency, 'three_ds_reference_id');
  trackPage(pageGroup, pageName);
}

export function add3DSRespDuration(data, pageGroup, pageName) {
  let resp_duration = window.fpti.resp_duration || {};
  resp_duration = Object.assign({}, resp_duration, data);
  window.fpti.resp_duration = resp_duration;
  trackPage(pageGroup, pageName);
}

export function add3DSChallengeStatus(data) {
  window.fpti.challenge_status = data;
}

export function addDonationAmount(amount, pageGroup, pageName) {
  window.fpti.amount = amount;
  trackPage(pageGroup, pageName);
}

export function addOnboardingBundleType(type = 'full') {
  window.fpti.onboardingBundleType = type;
}
